import Header from './components/Header';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <main>
      <Header />
      <About />
      <Products />
      <Features />
      <Contact />
    </main>
  );
}
